import { SearchInterface } from './top-search.interface';
import pubSub from '../utility/pub-sub';
export default class FilterButtoncategories {
  element: HTMLButtonElement;
  onFilterChanged: (filter: SearchInterface) => {}

  constructor(element: HTMLButtonElement, onFilterChanged: (filter: SearchInterface) => {}) {
    this.element = element;
    this.onFilterChanged = onFilterChanged;
    this.element.addEventListener('click', this.update);
  }

  update = (event: Event) => {
    const button = (event.currentTarget as HTMLButtonElement);
    const parent = button.parentElement;
    const allButtons = parent.querySelectorAll('.btn');
    const elements = [].slice.call(allButtons);
    elements.forEach((el: HTMLButtonElement) => {
      el.classList.remove('active');
    });
    button.classList.add('active');
    const value = button.getAttribute('data-value');
    const isAll = value === 'All';
    pubSub.publish('activeCategory', {
      data: value
    });


    if (value && isAll || value === 'Other') {
      this.onFilterChanged({ facet_section: isAll ? null : value });
    }
  };
}
